import styled from 'styled-components'



export const Container = styled.div`
    background: #fff;
    border-radius: 0px;
    margin: 30px 0;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;

   @media (min-width: 768px) {
    border-radius: 5px;
    width: 100%;
   }
`
 

export const HeaderList = styled.div`
   flex-wrap: wrap;
   display: flex;
   width: 100%;
   padding: 20px 20px 10px 20px;
   border-bottom: solid 2px #F6F6F6;
   @media (min-width: 768px) { 
      padding: 20px;
    }
    @media (min-width: 992px) { 
      padding: 20px;
    }
    @media (min-width: 1200px) { 
      padding: 20px;
    }
`
export const Title = styled.div`
   font-size: 16px;
   color: #4A4A4A;
   text-align: left;
   width: 100%;
   font-weight: 600;
`
export const Subtitle = styled.div`
   font-size: 14px;
   color: #4A4A4A;
   text-align: left;
   font-style: italic;
`
export const Cardlist = styled.div`
   flex-wrap: wrap;
   display: flex;
   padding: 0 20px 20px 20px;
   width: 100%;
   @media (min-width: 768px) { 
      padding: 0 20px 20px 20px;
    }
    @media (min-width: 992px) { 
      padding: 0 20px 20px 20px;
    }
    @media (min-width: 1200px) { 
      padding: 0 20px 20px 20px;
    }
    
`

export const Card = styled.div`
    display:flex;
    margin: 10px;
    @media (min-width: 768px) { 
        
    }
    @media (min-width: 992px) { 
        
    }
    @media (min-width: 1200px) { 
        
    }

    img{
        width: 142px;
        height: 56px;
    }

`